// extracted by mini-css-extract-plugin
module.exports = {"tagContent":"company-ai-usage-tag_component_tagContent__FUshP","tooltipText":"company-ai-usage-tag_component_tooltipText__AsdN5"};